import { type Tag } from '@hungryroot/rest';
import { isMeatProduct, isSeafoodProduct } from '@hungryroot/tags';
import { type ProteinSourcingVariant } from './ProteinSourcingDisclosure';

/**
 * A product can carry both a seafood BFL L1 tag and a meat BFL L1 tag, in
 * which case both disclosures render — seafood first, then meat.
 */
export function getProteinSourcingVariants(
  productTags: Pick<Tag, 'id'>[] | undefined | null
): ProteinSourcingVariant[] {
  const variants: ProteinSourcingVariant[] = [];

  if (isSeafoodProduct(productTags)) {
    variants.push('seafood');
  }

  if (isMeatProduct(productTags)) {
    variants.push('meat');
  }

  return variants;
}
